var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 3.33332V15.3333M10.6667 3.33332V15.3333M0.666667 7.33332H15.3333M0.666667 3.33332H15.3333M0.666667 11.3333H15.3333M0.666667 0.666656H15.3333V15.3333H0.666667V0.666656Z",
    stroke: "#868686",
    strokeWidth: 0.88888
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainTable);
export default __webpack_public_path__ + "static/media/mainTable.8ecc12cbb23385adf956a9f89bf85760.svg";
export { ForwardRef as ReactComponent };